import React, { useState } from "react";

import { Dimmer, Header, Icon, Segment } from "semantic-ui-react";
import { useIntl } from "react-intl";

interface SubAddButtonProps {
 onClicked?: () => void;
 header?: string;
}

const style = {
  noMargin: { margin: "0px" },
  addButton: { margin: "0px", padding: "35px 0px 0px 0px" }
};
const DEFAULT_PROPS = {
  onClicked: () => {},
  header: ""
}

const SubAddButton = (propsParam: SubAddButtonProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  const [active, setActive] = useState(false);

  const handleShow = () => {
    setActive(true);
  };
  const handleHide = () => {
    setActive(false);
  };

  return (
    <Dimmer.Dimmable
      blurring
      as={Segment}
      dimmed={active}
      onMouseEnter={handleShow}
      onMouseLeave={handleHide}
      onClick={props.onClicked}
    >
      <Header as="h1" disabled textAlign="center" style={style.noMargin}>
        {props.header}
      </Header>
      <Dimmer active={active} style={style.addButton}>
        <Header as="h4" icon>
          <Icon name="plus" inverted />
        </Header>
      </Dimmer>
    </Dimmer.Dimmable>
  );
};

export default React.memo(SubAddButton);
